import { render, staticRenderFns } from "./Statics.vue?vue&type=template&id=1a4ed4db&"
import script from "./Statics.vue?vue&type=script&lang=js&"
export * from "./Statics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports